/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Source: Xmedical.Domain/MasterData/MasterPermission.All
 * Generator: Xmedical.PermissionsGenerator
 *
 * This file is generated from the domain MasterPermissions definition.
 * Each Module-Action pair generates Read, Write, and Delete permissions.
 */

export enum Permissions {
  ClinicalAllergyListingDelete = 'Clinical.AllergyListing.Delete',
  ClinicalAllergyListingRead = 'Clinical.AllergyListing.Read',
  ClinicalAllergyListingWrite = 'Clinical.AllergyListing.Write',
  ClinicalAppointmentTypesDelete = 'Clinical.AppointmentTypes.Delete',
  ClinicalAppointmentTypesRead = 'Clinical.AppointmentTypes.Read',
  ClinicalAppointmentTypesWrite = 'Clinical.AppointmentTypes.Write',
  ClinicalAppointmentsDelete = 'Clinical.Appointments.Delete',
  ClinicalAppointmentsRead = 'Clinical.Appointments.Read',
  ClinicalAppointmentsWrite = 'Clinical.Appointments.Write',
  ClinicalBillingDelete = 'Clinical.Billing.Delete',
  ClinicalBillingRead = 'Clinical.Billing.Read',
  ClinicalBillingWrite = 'Clinical.Billing.Write',
  ClinicalCommentTemplatesDelete = 'Clinical.CommentTemplates.Delete',
  ClinicalCommentTemplatesRead = 'Clinical.CommentTemplates.Read',
  ClinicalCommentTemplatesWrite = 'Clinical.CommentTemplates.Write',
  ClinicalCommentTypesDelete = 'Clinical.CommentTypes.Delete',
  ClinicalCommentTypesRead = 'Clinical.CommentTypes.Read',
  ClinicalCommentTypesWrite = 'Clinical.CommentTypes.Write',
  ClinicalCommentsDelete = 'Clinical.Comments.Delete',
  ClinicalCommentsRead = 'Clinical.Comments.Read',
  ClinicalCommentsWrite = 'Clinical.Comments.Write',
  ClinicalCustomScriptsDelete = 'Clinical.CustomScripts.Delete',
  ClinicalCustomScriptsRead = 'Clinical.CustomScripts.Read',
  ClinicalCustomScriptsWrite = 'Clinical.CustomScripts.Write',
  ClinicalDiagnosisCodesDelete = 'Clinical.DiagnosisCodes.Delete',
  ClinicalDiagnosisCodesRead = 'Clinical.DiagnosisCodes.Read',
  ClinicalDiagnosisCodesWrite = 'Clinical.DiagnosisCodes.Write',
  ClinicalDoctorsDelete = 'Clinical.Doctors.Delete',
  ClinicalDoctorsRead = 'Clinical.Doctors.Read',
  ClinicalDoctorsWrite = 'Clinical.Doctors.Write',
  ClinicalDocumentsDelete = 'Clinical.Documents.Delete',
  ClinicalDocumentsRead = 'Clinical.Documents.Read',
  ClinicalDocumentsWrite = 'Clinical.Documents.Write',
  ClinicalDraftsDelete = 'Clinical.Drafts.Delete',
  ClinicalDraftsRead = 'Clinical.Drafts.Read',
  ClinicalDraftsWrite = 'Clinical.Drafts.Write',
  ClinicalEmailTemplatesDelete = 'Clinical.EmailTemplates.Delete',
  ClinicalEmailTemplatesRead = 'Clinical.EmailTemplates.Read',
  ClinicalEmailTemplatesWrite = 'Clinical.EmailTemplates.Write',
  ClinicalEmailsDelete = 'Clinical.Emails.Delete',
  ClinicalEmailsRead = 'Clinical.Emails.Read',
  ClinicalEmailsWrite = 'Clinical.Emails.Write',
  ClinicalMedicationDelete = 'Clinical.Medication.Delete',
  ClinicalMedicationRead = 'Clinical.Medication.Read',
  ClinicalMedicationWrite = 'Clinical.Medication.Write',
  ClinicalMessagesDelete = 'Clinical.Messages.Delete',
  ClinicalMessagesRead = 'Clinical.Messages.Read',
  ClinicalMessagesWrite = 'Clinical.Messages.Write',
  ClinicalPatientsDelete = 'Clinical.Patients.Delete',
  ClinicalPatientsRead = 'Clinical.Patients.Read',
  ClinicalPatientsWrite = 'Clinical.Patients.Write',
  ClinicalPracticesDelete = 'Clinical.Practices.Delete',
  ClinicalPracticesRead = 'Clinical.Practices.Read',
  ClinicalPracticesWrite = 'Clinical.Practices.Write',
  ClinicalProblemListingDelete = 'Clinical.ProblemListing.Delete',
  ClinicalProblemListingRead = 'Clinical.ProblemListing.Read',
  ClinicalProblemListingWrite = 'Clinical.ProblemListing.Write',
  ClinicalProceduresDelete = 'Clinical.Procedures.Delete',
  ClinicalProceduresRead = 'Clinical.Procedures.Read',
  ClinicalProceduresWrite = 'Clinical.Procedures.Write',
  ClinicalReferralsDelete = 'Clinical.Referrals.Delete',
  ClinicalReferralsRead = 'Clinical.Referrals.Read',
  ClinicalReferralsWrite = 'Clinical.Referrals.Write',
  ClinicalReportTemplatesDelete = 'Clinical.ReportTemplates.Delete',
  ClinicalReportTemplatesRead = 'Clinical.ReportTemplates.Read',
  ClinicalReportTemplatesWrite = 'Clinical.ReportTemplates.Write',
  ClinicalReportsDelete = 'Clinical.Reports.Delete',
  ClinicalReportsRead = 'Clinical.Reports.Read',
  ClinicalReportsWrite = 'Clinical.Reports.Write',
  ClinicalScriptsDelete = 'Clinical.Scripts.Delete',
  ClinicalScriptsRead = 'Clinical.Scripts.Read',
  ClinicalScriptsWrite = 'Clinical.Scripts.Write',
  ClinicalSystemTemplatesDelete = 'Clinical.SystemTemplates.Delete',
  ClinicalSystemTemplatesRead = 'Clinical.SystemTemplates.Read',
  ClinicalSystemTemplatesWrite = 'Clinical.SystemTemplates.Write',
  ClinicalTheaterSlateDelete = 'Clinical.TheaterSlate.Delete',
  ClinicalTheaterSlateRead = 'Clinical.TheaterSlate.Read',
  ClinicalTheaterSlateWrite = 'Clinical.TheaterSlate.Write',
  ClinicalTranscribeDelete = 'Clinical.Transcribe.Delete',
  ClinicalTranscribeRead = 'Clinical.Transcribe.Read',
  ClinicalTranscribeWrite = 'Clinical.Transcribe.Write',
  ClinicalTreatmentPlansDelete = 'Clinical.TreatmentPlans.Delete',
  ClinicalTreatmentPlansRead = 'Clinical.TreatmentPlans.Read',
  ClinicalTreatmentPlansWrite = 'Clinical.TreatmentPlans.Write',
  ClinicalTreatmentPlansListingDelete = 'Clinical.TreatmentPlansListing.Delete',
  ClinicalTreatmentPlansListingRead = 'Clinical.TreatmentPlansListing.Read',
  ClinicalTreatmentPlansListingWrite = 'Clinical.TreatmentPlansListing.Write',
  ClinicalUploadsDelete = 'Clinical.Uploads.Delete',
  ClinicalUploadsRead = 'Clinical.Uploads.Read',
  ClinicalUploadsWrite = 'Clinical.Uploads.Write',
  ReportBuilderReportTemplatesDelete = 'ReportBuilder.ReportTemplates.Delete',
  ReportBuilderReportTemplatesRead = 'ReportBuilder.ReportTemplates.Read',
  ReportBuilderReportTemplatesWrite = 'ReportBuilder.ReportTemplates.Write',
  ReportBuilderSystemTemplatesDelete = 'ReportBuilder.SystemTemplates.Delete',
  ReportBuilderSystemTemplatesRead = 'ReportBuilder.SystemTemplates.Read',
  ReportBuilderSystemTemplatesWrite = 'ReportBuilder.SystemTemplates.Write',
  Superuser = 'Superuser',
  UploadsUploadsDelete = 'Uploads.Uploads.Delete',
  UploadsUploadsRead = 'Uploads.Uploads.Read',
  UploadsUploadsWrite = 'Uploads.Uploads.Write'
}
